import React from "react";
import PDF from "react-pdf-js";

export default function MessMenu() {
  return (
    <div style={{ padding: '0 20px', minHeight: '80vh' }}>
      <h2
        style={{
          fontSize: "1.8rem",
          marginBottom: "20px",
          fontWeight: 600,
        }}
      >Mess Menu</h2>
      <iframe src="files/mess-menu.pdf" width="100%" height="800px" />
    </div>
  );
}
